import { z } from 'zod';
import type { EstadoAprobacion, TipoAprobacion } from '../estados';

export const resolverAprobacionSchema = z.object({
  decision: z.enum(['aprobar', 'rechazar']),
  nota: z.string().trim().max(300).optional(),
});
export type ResolverAprobacionInput = z.infer<typeof resolverAprobacionSchema>;

/** Token de Expo Push (`ExponentPushToken[...]`) o de FCM nativo. */
export const dispositivoSchema = z.object({
  token: z.string().trim().min(20).max(300).regex(/^[\w:\-[\]]+$/, 'Token inválido'),
  plataforma: z.enum(['android', 'ios', 'web']),
});
export type DispositivoInput = z.infer<typeof dispositivoSchema>;

export interface AprobacionVista {
  id: string;
  tipo: TipoAprobacion;
  titulo: string;
  descripcion: string | null;
  estado: EstadoAprobacion;
  solicitante: string;
  resueltaPor: string | null;
  nota: string | null;
  createdAt: string;
  resueltaEn: string | null;
}
